import AccordionSummary from '@mui/material/AccordionSummary';
import { ChevronDownIcon } from 'src/icons/ChevronDownIcon';
import { theme } from 'src/theme/mui-theme';
import { Accordion, AccordionDetails, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ts } from 'src/utils/translate';
import { ElectricalCabinetIcon } from 'src/icons/planner/ElectricalCabinetIcon';
import { RackCabinetIcon } from 'src/icons/planner/RackCabinetIcon';
import {
  ELECTRICAL_CABINET_DRAG,
  RACK_CABINET_DRAG
} from 'src/pages/PlannerPage/DeviceView/hooks/DragAndDrop/draggableDevices';
import { DraggableListItem } from 'src/pages/PlannerPage/DeviceView/hooks/DragAndDrop/DraggableListItem';
import { SelectedDevice } from 'src/api/planner-ui-slice';

const ELECTRICAL_CABINET_KEY = 'electrical_cabinet';
const RACK_CABINET_KEY = 'rack_cabinet';

interface DeviceViewCabinetsProps {
    selectedDevice: SelectedDevice;
}

export function DeviceViewCabinets({
    selectedDevice,
}: DeviceViewCabinetsProps) {
    const selectedDeviceProductNameId = selectedDevice.productNameId;
    const isElectricalSelected = selectedDeviceProductNameId === ELECTRICAL_CABINET_KEY;
    const isRackSelected = selectedDeviceProductNameId === RACK_CABINET_KEY;
    const hasCabinetSelected = isElectricalSelected || isRackSelected;

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        setExpanded(hasCabinetSelected);
    }, [selectedDevice]);

    return (
        <Accordion
            key='cabinets'
            disableGutters
            elevation={0}
            square
            sx={{
                border: 'none',
                boxShadow: 'none',
                mb: 0,
                '&::before': { display: 'none' },
            }}
            expanded={expanded}
            onChange={(_, isExpanded) => setExpanded(isExpanded)}
        >
            <AccordionSummary
                expandIcon={
                    <ChevronDownIcon
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: 28,
                        }}
                    />
                }
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="h6" color={theme.palette.primary.main}>
                            {ts('planner_cabinets', 'Cabinets')}
                        </Typography>
                    </Stack>
                </Stack>
            </AccordionSummary>

            <AccordionDetails>
                <DraggableListItem
                    dragData={ELECTRICAL_CABINET_DRAG}
                    icon={<ElectricalCabinetIcon />}
                    label={ts('planner_electrical_cabinet', 'Electrical Cabinet')}
                    selected={isElectricalSelected}
                />
                <DraggableListItem
                    dragData={RACK_CABINET_DRAG}
                    icon={<RackCabinetIcon />}
                    label={ts('planner_rack_cabinet', 'Rack Cabinet')}
                    selected={isRackSelected}
                />
            </AccordionDetails>
        </Accordion>
    );
}